import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { JobPostingInterviewOpinionScaleTypes } from '../../enums/job-posting-interview-opinion-scale-types.enum';

@Component({
    selector: 'app-interview-opinion-scale',
    templateUrl: './interview-opinion-scale.template.html',
    styleUrls: ['interview-opinion-scale.style.scss'],
})
export class InterviewOpinionScaleComponent implements OnInit {
    @Input() interviewQuestion: InterviewQuestion;
    @Input() value: number;
    @Output() valueChange: EventEmitter<number[]> = new EventEmitter<number[]>();

    imgSrc = '/assets/icons/stars/star-default.svg';

    hoverSvg = '/assets/icons/stars/star-active.svg';
    activeSvg = '/assets/icons/stars/star-active.svg';
    defaultSvg = '/assets/icons/stars/star-default.svg';
    activeStarIndex: number;

    opinionScaleNumbers = [1, 2, 3, 4, 5];
    opinionScaleStars = [1, 2, 3, 4, 5];
    svgState = Array(5).fill(this.defaultSvg);
    jobPostingInterviewOpinionScaleTypes = JobPostingInterviewOpinionScaleTypes;

    ngOnInit(): void {
        if (this.value) {
            this.svgState[this.value - 1] = this.activeSvg;
            this.activeStarIndex = this.value - 1;
        }
    }

    onClick(scaleValue: number): void {
        if (scaleValue === this.activeStarIndex + 1) {
            return;
        }

        // Set previously active svg to inactive
        this.svgState[this.activeStarIndex] = this.defaultSvg;
        this.svgState[scaleValue - 1] = this.activeSvg;

        // Update index for next time
        this.activeStarIndex = scaleValue - 1;
        this.value = scaleValue;
        this.valueChange.emit([scaleValue]);
    }

    getImgSrc(index: number): string {
        return this.svgState[index];
    }

    onMouseEnter(index: number): void {
        this.svgState[index] = this.hoverSvg;
    }

    onMouseLeave(index: number): void {
        if (index === this.activeStarIndex) {
            return;
        }

        this.svgState[index] = this.defaultSvg;
    }
}
